import { atomWithReset } from 'jotai/utils';

import { PurchaseOrderFields } from './NetSuitePurchaseOrderRequestForm.types';

export const netSuiteSendToSupplierState = atomWithReset(false);

export const netSuitePurchaseOrderFieldValuesState = atomWithReset<Partial<PurchaseOrderFields>>({});
